import { Card } from 'react-bootstrap';
import { Chip, EarlyAccessIndicator, Typography } from 'Components/atoms';
import { INTEGRATED } from 'Core-utils/constants/constants';
import classnames from 'classnames';
import './styles.scss';

interface VendorCardProps {
    id: string;
    imageUrl: string;
    title: string;
    subTitle?: string;
    subText: string;
    isIntegrated: boolean;
    isEarlyAccess?: boolean;
    handleCard: (_id: string) => void;
}

const VendorCard = ({
    id,
    imageUrl,
    title,
    subTitle,
    subText,
    isIntegrated = false,
    isEarlyAccess = false,
    handleCard,
}: VendorCardProps) => {
    const cardClassName = classnames('vendor-card bg-text-black d-flex', {
        disabled: isIntegrated,
    });

    return (
        <div className="vendor-card" data-testid="vendor-card">
            {isIntegrated && <Chip value={INTEGRATED} variant="integrated_card_variant" />}
            <Card className={cardClassName} onClick={() => handleCard(id)} data-testid={`${title}`}>
                <div className="vendor-card__image-text d-flex flex-column align-items-center">
                    {imageUrl && <img src={imageUrl} alt={`${title}-logo`} className="vendor-card__icon" />}
                    <div className="vendor-card__title-row d-flex align-items-center justify-content-center gap-2">
                        <Typography variant="subtitle5" color="text-high-emphasis">
                            {title}
                        </Typography>
                        {isEarlyAccess && <EarlyAccessIndicator />}
                    </div>
                    <Typography variant="body7" color="text-medium-emphasis">
                        {subTitle}
                    </Typography>
                    <div className="divider bg-structural-selected" />
                </div>
                <div className="text-center">
                    <Typography variant="body2" color="text-medium-emphasis">
                        {subText}
                    </Typography>
                </div>
            </Card>
        </div>
    );
};

export default VendorCard;
